const SYSTEM_ROLES = ['READ', 'EDIT', 'MANAGE', 'CUSTOM', 'OWNER', 'STRANGER', 'LABEL'];
export function isSystemRole(role) {
    return SYSTEM_ROLES.includes(role.toLocaleUpperCase());
}
export function getRoleDisplayName(role, t, roleName) {
    if (isSystemRole(role)) {
        return t(`workspace.share.role.${role.toLocaleUpperCase()}`);
    }
    if (roleName) {
        return roleName;
    }
    return t('workspace.share.role.CUSTOM');
}
